// import { Commit } from 'vuex'
import moment from 'moment'
import { Action, getModule, Module, Mutation, VuexModule, config } from 'vuex-module-decorators'
import store from '@/store'

// 解决action中触发网络请求，网络请求失败后，会产生错误日志
config.rawError = true

class CurrentSystemTime {
  timestamp: number

  constructor(timestamp: number) {
    this.timestamp = parseInt(`${timestamp}`)
  }

  getFormat(format: string) {
    return moment(this.timestamp).format(format)
  }
}

interface State {
  currentSystemTime: CurrentSystemTime
}

@Module({ namespaced: true, name: 'RootModule', store, dynamic: true })
class RootModule extends VuexModule implements State {
  title = '四川省建设从业人员考前培训平台'

  currentSystemTime: CurrentSystemTime = new CurrentSystemTime(0)

  @Action
  setTitle(title?: string) {
    document.title = title || this.title
  }

  @Action
  setCurrentSystemTime(timestamp: number) {
    if (!timestamp) return
    this.SET_CURRENT_SYSTEM_TIME(Number(timestamp))
  }

  @Mutation
  SET_CURRENT_SYSTEM_TIME(timestamp: number) {
    this.currentSystemTime.timestamp = timestamp
  }

  get getCurrentSystemTimeDate() {
    return () => {
      if (this.currentSystemTime?.timestamp) {
        return new Date(this.currentSystemTime.timestamp)
      } else {
        return new Date()
      }
    }
  }
}

export default getModule(RootModule)
